import { createContext } from 'react';

const procedimientoContext = createContext();

export default procedimientoContext;